@if (errorFindingContract) {
  <div>Could not find contract information.</div>
}

<app-balsa-card
  *ngIf="!errorFindingContract"
  [title]="actionName"
  titleIcon="assignment"
  [loading]="isLoading"
  [centered]="true"
  cardMargin="0 0 0.5rem 0"
  [hasDivider]="true">
  <ng-container class="card-header">
    <div class="header-actions">
      @if (!isReadOnly) {
        <button mat-stroked-button color="warn" (click)="onCancel()">
          {{ 'BackOffice.ManageContracts.Contract.CancelButton' | translate: locale.language }}
        </button>
      }

      @if (isSuperAdmin && !isReadOnly && create) {
        <button [disabled]="!formValid()" mat-stroked-button color="primary" (click)="onCreate()">
          {{ 'BackOffice.ManageContracts.Contract.CreateButton' | translate: locale.language }}
        </button>
      }

      @if (isSuperAdmin && !isReadOnly && !create) {
        <button [disabled]="!formValid()" mat-stroked-button color="primary" (click)="onUpdate()">
          {{ 'BackOffice.ManageContracts.Contract.SaveButton' | translate: locale.language }}
        </button>
      }
    </div>
  </ng-container>

  <ng-container class="card-content">
    <div [formGroup]="contractForm">
      @if (create) {
        <div>
          <app-tenant-search
            [initialTenantId]="tenantId?.toString()"
            (tenantSelected)="onTenantSelected($event)"
            [inputStyle]="{ 'margin-right': '0.25rem', width: '408px' }"
            [useDefaultStyling]="true">
          </app-tenant-search>
        </div>
      }
      @if (!create) {
        <div class="flex-row">
          <div class="flex-col mx-1">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'BackOffice.ManageContracts.Contract.TenantName' | translate: locale.language }}</mat-label>
              <input matInput autocomplete="off" type="text" id="tenantName" formControlName="tenantName" />
            </mat-form-field>
          </div>
        </div>
      }
      @if (isSuperAdmin) {
        <div class="flex-row">
          <div class="flex-col mx-1">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'BackOffice.ManageContracts.Contract.ServiceFee' | translate: locale.language }}</mat-label>
              <input
                matInput
                autocomplete="off"
                type="text"
                id="serviceFee"
                formControlName="serviceFee"
                mask="separator.2"
                thousandSeparator=","
                prefix="$ " />
            </mat-form-field>
          </div>
          <div class="flex-col mx-1">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                'BackOffice.ManageContracts.Contract.ClientContact' | translate: locale.language
              }}</mat-label>
              <input matInput autocomplete="off" type="text" id="clientContact" formControlName="clientContact" />
            </mat-form-field>
          </div>
        </div>
      }

      @if (displayAccountManagerData) {
        <div class="flex-row">
          <div class="flex-col mx-1">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                'BackOffice.ManageContracts.Contract.AccountManager' | translate: locale.language
              }}</mat-label>
              <input matInput autocomplete="off" type="text" id="accountManager" formControlName="accountManager" />
            </mat-form-field>
          </div>
          <div class="flex-col mx-1">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                'BackOffice.ManageContracts.Contract.AccountManagerEmail' | translate: locale.language
              }}</mat-label>
              <input
                matInput
                autocomplete="off"
                type="text"
                id="accountManagerEmail"
                formControlName="accountManagerEmail" />
            </mat-form-field>
          </div>
        </div>
      }
      @if (isSuperAdmin) {
        <div class="flex-row">
          <div class="flex-col mx-1">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                'BackOffice.ManageContracts.Contract.InvoiceFrequency' | translate: locale.language
              }}</mat-label>
              <input matInput autocomplete="off" type="text" id="invoiceFrequency" formControlName="invoiceFrequency" />
            </mat-form-field>
          </div>
          <div class="flex-col mx-1">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'BackOffice.ManageContracts.Contract.PlanType' | translate: locale.language }}</mat-label>
              <input matInput autocomplete="off" type="text" id="planType" formControlName="planType" />
            </mat-form-field>
          </div>
        </div>
      }
      @if (isSuperAdmin) {
        <div class="flex-row">
          <div class="flex-col mx-1">
            <mat-form-field class="date-fields" appearance="outline">
              <mat-label>{{
                'BackOffice.ManageContracts.Contract.ContractStartDate' | translate: locale.language
              }}</mat-label>
              <input
                matInput
                [matDatepickerFilter]="startDateFilter"
                [matDatepicker]="startDate"
                (dateChange)="startDateChange($event)"
                value="selecteStartDate"
                [formControl]="startFormControl" />
              <mat-datepicker-toggle [disabled]="isReadOnly" matIconSuffix [for]="startDate"></mat-datepicker-toggle>
              <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="flex-col mx-1">
            <mat-form-field class="date-fields" appearance="outline">
              <mat-label>{{
                'BackOffice.ManageContracts.Contract.ServiceEndDate' | translate: locale.language
              }}</mat-label>
              <input
                matInput
                [matDatepickerFilter]="endDateFilter"
                [matDatepicker]="endDate"
                (dateChange)="endDateChange($event)"
                value="selectedEndDate"
                [formControl]="endFormControl" />
              <mat-datepicker-toggle [disabled]="isReadOnly" matIconSuffix [for]="endDate"></mat-datepicker-toggle>
              <mat-datepicker #endDate></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="flex-col mx-1">
          <div class="flex-row">
            <mat-slide-toggle id="primary-checkbox" formControlName="isActive">
              {{ 'BackOffice.ManageContracts.Contract.Active' | translate: locale.language }}
            </mat-slide-toggle>
          </div>
        </div>
      }
      @if (!create) {
        <mat-tab-group style="margin-top: 0.5rem" mat-stretch-tabs="true" [selectedIndex]="selectedTabIndex">
          <mat-tab label="{{ 'BackOffice.ManageContracts.UsageOverview' | translate: locale.language }}">
            @if (limits()?.length) {
              <div class="contract-overview-section">
                <app-contract-limit-overview
                  [limits]="limits()"
                  [contractId]="contractId"
                  [tenantId]="tenantId?.toString()"
                  [startDate]="selectedStartDate"
                  [endDate]="selectedEndDate">
                </app-contract-limit-overview>
              </div>
            } @else {
              <div class="no-limits-message">
                {{ 'BackOffice.ManageContracts.Contract.NoContractLimits' | translate: locale.language }}
              </div>
            }
          </mat-tab>
          <mat-tab label="{{ 'BackOffice.ManageContracts.ContractOverages' | translate: locale.language }}">
            @if (overages()?.length) {
              <div class="contract-overview-section">
                <app-contract-limit-overview
                  [limits]="overages()"
                  [contractId]="contractId"
                  [tenantId]="tenantId?.toString()"
                  [startDate]="selectedStartDate"
                  [endDate]="selectedEndDate">
                </app-contract-limit-overview>
              </div>
            } @else {
              <div class="no-limits-message">
                {{ 'BackOffice.ManageContracts.Contract.NoContractOverages' | translate: locale.language }}
              </div>
            }
          </mat-tab>
          <mat-tab label="{{ 'BackOffice.ManageContracts.ContractLimits' | translate: locale.language }}">
            <div class="contract-limits-section">
              <mat-table #table [dataSource]="dataSource" [ngClass]="{ hidden: !hasLimits() }">
                <ng-container matColumnDef="category">
                  <mat-header-cell *matHeaderCellDef>
                    {{ 'BackOffice.ManageContracts.ContractLimit.Category' | translate: locale.language }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="category-cell">{{ element.category }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="code">
                  <mat-header-cell *matHeaderCellDef>
                    {{ 'BackOffice.ManageContracts.ContractLimit.Code' | translate: locale.language }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-chip-set>
                      @for (code of splitCode(element.code); track $index) {
                        <mat-chip>
                          {{ code }}
                        </mat-chip>
                      }
                    </mat-chip-set>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="limitation">
                  <mat-header-cell *matHeaderCellDef>
                    {{ 'BackOffice.ManageContracts.ContractLimit.Limit' | translate: locale.language }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.limitation | number }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="priority">
                  <mat-header-cell *matHeaderCellDef>
                    {{ 'BackOffice.ManageContracts.ContractLimit.Priority' | translate: locale.language }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.priority }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="edit">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <button
                      mat-icon-button
                      (click)="editLimit(element)"
                      [attr.aria-label]="'Edit ' + element.priority + ' ' + element.code + ' limit'">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="delete">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <button
                      mat-icon-button
                      (click)="confirmDeleteContractLimit(element)"
                      [attr.aria-label]="'Delete ' + element.priority + ' ' + element.code + ' limit'">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="limitDisplayColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: limitDisplayColumns"></mat-row>
              </mat-table>

              @if (!hasLimits()) {
                <div class="no-limits-message">
                  {{ 'BackOffice.ManageContracts.Contract.NoContractLimits' | translate: locale.language }}
                </div>
              }

              <div class="table-actions">
                <button mat-stroked-button color="primary" *ngIf="!isReadOnly" (click)="createLimit()">
                  Add Limit
                </button>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      }

      @if (isSuperAdmin) {
        <div class="overage-fees-section">
          <div class="flex-row">
            <div class="flex-col mx-1">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>
                  {{ 'BackOffice.ManageContracts.Contract.VoiceOverageFee' | translate: locale.language }}
                </mat-label>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  id="voiceOverageFee"
                  formControlName="voiceOverageFee"
                  mask="separator.2"
                  thousandSeparator=","
                  prefix="$ " />
              </mat-form-field>
            </div>
            <div class="flex-col mx-1">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>
                  {{ 'BackOffice.ManageContracts.Contract.SmsOverageFee' | translate: locale.language }}
                </mat-label>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  id="smsOverageFee"
                  formControlName="smsOverageFee"
                  mask="separator.2"
                  thousandSeparator=","
                  prefix="$ " />
              </mat-form-field>
            </div>
          </div>
        </div>
      }
      @if (isSuperAdmin) {
        <div class="notes-section">
          <div>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                'BackOffice.ManageContracts.Contract.BackOfficeNotes' | translate: locale.language
              }}</mat-label>
              <textarea
                [cdkTextareaAutosize]="true"
                [cdkAutosizeMinRows]="3"
                [cdkAutosizeMaxRows]="8"
                matInput
                id="backOfficeNotes"
                formControlName="backOfficeNotes"></textarea>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                'BackOffice.ManageContracts.Contract.TenantNotes' | translate: locale.language
              }}</mat-label>
              <textarea
                [cdkTextareaAutosize]="true"
                [cdkAutosizeMinRows]="3"
                [cdkAutosizeMaxRows]="8"
                matInput
                id="tenantNotes"
                formControlName="tenantNotes"></textarea>
            </mat-form-field>
          </div>

          <div class="contract-help-text">
            <p>
              {{ 'BackOffice.ManageContracts.Contract.ContractQuestions' | translate: locale.language }}
            </p>
          </div>
        </div>
      }
    </div>
  </ng-container>
</app-balsa-card>
